"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _stencilReactThemeDefault = require("@amzn/stencil-react-theme-default");
var _propTypes = require("../prop-types");
var _utils = require("../utils");
var _View = _interopRequireDefault(require("./View"));
var _react2 = require("@emotion/react");
const FlexBase = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    gridGap,
    rowGap,
    columnGap,
    children,
    container: Container = _View.default,
    ...outerProps
  } = _ref;
  const containerProps = {
    ...outerProps,
    ...(0, _utils.getSpacingStyles)(['rowGap', 'columnGap'], {
      rowGap,
      columnGap
    }, _stencilReactThemeDefault.spacePropAdapter)
  };
  if (gridGap) {
    containerProps.gap = (0, _utils.px)((0, _utils.cssProp)(_stencilReactThemeDefault.spacePropAdapter, gridGap));
  }
  return (0, _react2.jsx)(Container, (0, _extends2.default)({
    display: "flex",
    ref: ref
  }, containerProps), children);
});

// Force TS to accept .withComponent
const FlexStyled = FlexBase;
FlexStyled.withComponent = tag => {
  const Container = _View.default.withComponent(tag, process.env.NODE_ENV === "production" ? {
    target: "e1s41o6r0"
  } : {
    target: "e1s41o6r0",
    label: "Container"
  });
  return /*#__PURE__*/_react.default.forwardRef((props, ref) => (0, _react2.jsx)(FlexBase, (0, _extends2.default)({}, props, {
    ref: ref,
    container: Container
  })));
};
const FlexBaseWithDocs = (0, _stencilReactDesc.describe)(FlexStyled).description('View based on flex used for implementing layouts.');
FlexBaseWithDocs.propTypes = {
  ..._View.default.describedPropTypes,
  flexDirection: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-direction' property for the element.").isRequired,
  gridGap: (0, _propTypes.cssValue)().description("Sets the CSS 'gap' property for the element."),
  rowGap: (0, _propTypes.cssValue)().description("Sets the CSS 'row-gap' property for the element."),
  columnGap: (0, _propTypes.cssValue)().description("Sets the CSS 'col-gap' property for the element."),
  children: _stencilReactDesc.PropTypes.node.description('Elements to lay out horizontally.')
};
const Flex = (0, _utils.withTestAttributes)({
  component: 'StencilReactFlex'
})(FlexBaseWithDocs);
Flex.displayName = 'Flex';
var _default = exports.default = Flex;